var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverdueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20973 1.39083C9.5339 0.869725 10.2924 0.869724 10.6166 1.39083L18.9172 14.734C19.2605 15.2858 18.8637 16 18.2138 16H1.61245C0.962562 16 0.565751 15.2858 0.909037 14.734L9.20973 1.39083Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90308 7.02148V10.479",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.057 13.3628C11.057 14.0001 10.5404 14.5167 9.90311 14.5167C9.26586 14.5167 8.74927 14.0001 8.74927 13.3628C8.74927 12.7256 9.26586 12.209 9.90311 12.209C10.5404 12.209 11.057 12.7256 11.057 13.3628Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueIcon);
export default __webpack_public_path__ + "static/media/overdue-icon.01d5d300fa81223bccd5ed9ee4aa3704.svg";
export { ForwardRef as ReactComponent };